import { useBoolean } from '@qfa/react-components';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useEntityDrawerState = () => {
  const { pathname } = useLocation();
  const [{ toggle: toggleEntities, on: openEntities }, isEntitiesOpen] = useBoolean(
    pathname !== '/' && !pathname.includes('mapConfigs')
  );

  const contextValue = useMemo(
    () => ({
      isEntitiesOpen,
      toggleEntities,
      openEntities,
    }),
    [isEntitiesOpen, toggleEntities, openEntities]
  );

  return contextValue;
};
